import React, { Component } from 'react';
import { adminservice } from '../../services/admin.service';
import Loader from '../../_helpers/Loader';
import { isStringEmpty } from '../../_helpers/string_helper';
import { historypush } from '../../_helpers/utilities';
import DataTable from 'react-data-table-component';
import { UIGridToSheet,SheetToArrayBuffer } from '../../_helpers/utilities';
import { UncontrolledTooltip } from 'reactstrap';

const paginationComponentOptions = {
    noRowsPerPage:true,
};

const XLSX = require("xlsx"); 
class searchMembers extends Component {
    constructor(props) {
        super(props);
        this.state = { 
            isLoading:false,
            slectedGrade:"ALL",
            totalRows:'',
            noOfRecordsToFetch:50,
            paginationDefaultPage:1,
            memberList:[],
            searchValue:'',
        };
    }

    componentDidMount=()=>{
        this.getMemberListBasedonClass();
    }

    /* <summary>
    date: 06-09-2022
    Name: VD
    description: This is used to get the list of all members based on their class/Grade
    <summary>*/ 
    getMemberListBasedonClass=async(page = undefined)=>{
        try{
            const{noOfRecordsToFetch,searchValue,slectedGrade}=this.state;
            let prevPageValue = page ? noOfRecordsToFetch * (page - 1) : 0;
            var pageNumber  = page == undefined ? 1 : page;
            this.setState({isLoading:true, paginationDefaultPage: pageNumber})
            var response=await adminservice.GetMemberListBasedonClass(prevPageValue,noOfRecordsToFetch,searchValue,slectedGrade);
            if(response.status === 200){
                if(response.data.length > 0){
                    this.setState({
                        memberList:response.data,
                        totalRows:response.data[0].totalRows,
                    })
                }else{
                    this.setState({
                        memberList:[],
                        totalRows:0,
                    })
                }
                this.setState({isLoading:false})
            }else if(response.status===401){
                this.setState({isLoading:false})
                localStorage.clear();
                historypush('/login');
            }else{
                this.setState({isLoading:false})
            }
            this.setState({isLoading:false})
        }catch(ex){
            return ""
        }
    }
    OnEventChange(event) {
        this.setState({
            slectedGrade: event.target.value,
          },
          async () => {
            this.getMemberListBasedonClass();
          });
    }

    onSearchTextChange = async(event) => {
        var inputValue = event.target.value;
     
        this.setState({
            searchValue: inputValue,
        },async()=>{
        if(inputValue.length == 0){
            this.getMemberListBasedonClass();
        }})
    };

    onSearchClick=()=>{
        if(!isStringEmpty(this.state.searchValue))
        {
            this.getMemberListBasedonClass();
        }
    }

    Header = [
        {
          name: <th>Class</th>,
          selector: (row) => row.grade,
          left: true,
          grow: 1,
          width:'140px',
        },
        {
            name: <th>Name</th>,
            selector: (row) => <div key={row.memberId}>
            <span className="view" id={'UncontrolledTooltipfirstName' + row.memberId} > {row.firstName}</span> 
            <UncontrolledTooltip placement="top" target={'UncontrolledTooltipfirstName' + row.memberId}>
            {row.firstName}
            </UncontrolledTooltip>
            </div>,
            left: true,
            grow: 1,
            width:'125px',
        },
        {
            name: <th className="question-doc">Surname</th>,
            selector: (row) => <div key={row.memberId}>
            <span className="view" id={'UncontrolledTooltipsurname' + row.memberId} > {row.surname}</span> 
            <UncontrolledTooltip placement="top" target={'UncontrolledTooltipsurname' + row.memberId}>
            {row.surname}
            </UncontrolledTooltip>
            </div>,
            left: true,
            grow: 1,
            width: "130px",
        },
        {
            name: <th className="question-doc">Address</th>,
            selector: (row) => <div key={row.memberId}>
            <span className="view" id={'UncontrolledTooltiphouseNo' + row.memberId} > {row.houseNo}</span> 
            <UncontrolledTooltip placement="top" target={'UncontrolledTooltiphouseNo' + row.memberId}>
            {row.houseNo}
            </UncontrolledTooltip>
            </div>,
            left: true,
            grow: 1,
            width: "180px",
        },
        {
            name: <th className="question-doc">Place</th>,
            selector: (row) => <div key={row.memberId}>
            <span className="view" id={'UncontrolledTooltipbranch' + row.memberId} > {row.branch}</span> 
            <UncontrolledTooltip placement="top" target={'UncontrolledTooltipbranch' + row.memberId}>
            {row.branch}
            </UncontrolledTooltip>
            </div>,
            left: true,
            grow: 1,
            width: "130px",
        },
        {
            name: <th className="question-doc">Level 1 Classification</th>,
            selector: (row) => <div key={row.memberId}>
            <span className="view" id={'UncontrolledTooltiplevel1' + row.memberId} > {row.classificationLevel1Name}</span> 
            <UncontrolledTooltip placement="top" target={'UncontrolledTooltiplevel1' + row.memberId}>
            {row.classificationLevel1Name}
            </UncontrolledTooltip>
            </div>,
            left: true,
            grow: 1,
            width: "165px",
        },
        {
            name: <th className="question-doc">Level 2 Classification</th>,
            selector: (row) => <div key={row.memberId}>
            <span className="view" id={'UncontrolledTooltiplevel2' + row.memberId} > {row.classificationLevel2Name}</span> 
            <UncontrolledTooltip placement="top" target={'UncontrolledTooltiplevel2' + row.memberId}>
            {row.classificationLevel2Name}
            </UncontrolledTooltip>
            </div>,
            left: true,
            grow: 1,
            width: "165px",
        },
        {
            name: <th className="question-doc">Email</th>,
            selector: (row) => <div key={row.memberId}>
            <span className="view" id={'UncontrolledTooltipemail' + row.memberId} > {row.email}</span> 
            <UncontrolledTooltip placement="top" target={'UncontrolledTooltipemail' + row.memberId}>
            {row.email}
            </UncontrolledTooltip>
            </div>,
            left: true,
            grow: 1,
            width: "210px",
        }
    ]

    exportFile=()=>{
        this.downloadMemberExportData();
    }

    /* <summary>
    date: 06-09-2022
    Name: VD
    description: This is used to call all the details based on the grade for export
    <summary>*/ 
    downloadMemberExportData=async()=>{
        try{
            this.setState({isLoading:true});
            var response=await adminservice.ExportMemberListBasedonClass(this.state.slectedGrade);
            if(response.status == 200){
                this.bindExportMemberData(response.data);
            }
            
            this.setState({isLoading:false});
        }catch(ex){
            return "";
        }
    }

    /* <summary>
    date: 06-09-2022
    Name: VD
    description: This is used to bind the data in the excel for export
    <summary>*/ 
    bindExportMemberData = (data) => {
        try {
          var dataToAdd = [...data].map((item) => item);
          var sheetName = "sheet1";
          var wopts = { bookType: "xlsx", bookSST: true, type: "binary" };
          var columns = [
            "Class",
            "Name",
            "Surname",
            "Address",
            "Place",
            "Email",
          ];
    
          //width
          var wscols = [
            { wch: 15 },
            { wch: 15 },
            { wch: 25 },
            { wch: 25 },
            { wch: 15 },
          ];
    
          var data = [];
          dataToAdd.forEach((element) => {
            // const badgeNumberCommaString = element.map(
            //   (x) => x.badgeNumber
            // ).join(",");
    
            data.push([
                element["class"],
                element["firstName"],
                element["surName"],
                element["address"],
                element["branch"],
                element["email"],
            ]);
          });
          var wb = XLSX.utils.book_new();
          var ws = UIGridToSheet(data, columns);
    
          //width
          ws["!cols"] = wscols;
    
          XLSX.utils.book_append_sheet(wb, ws, sheetName);
          var wbout = XLSX.write(wb, wopts);
          const url = window.URL.createObjectURL(
            new Blob([SheetToArrayBuffer(wbout)], {
              type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            })
          );
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "Members Data.xlsx"); //or any other extension
          document.body.appendChild(link);
          link.click();
          // saveAs(
          //   new Blob([this.s2ab(wbout)], { type: "application/octet-stream" }),
          //   fileName
          // );
        } catch (error) {
          
        }
    };

    goBack=()=>{
        historypush('/memberportal');
    }

    render() {
        const{
            isLoading,
            slectedGrade,
            totalRows,
            searchValue,
            memberList,
        }=this.state;
        return (
            <div className="member-body">
                {isLoading && <Loader />}
                <div className="about">
                    <div className="container">
                    <div className="row">
                        <div className="col-md-6">
                        <h2 className="heading">Search Member</h2>
                        </div>
                        <div className="col-md-6 search-mob">
                        {/* <button 
                            type="button" className="btn Submit-btn" 
                            style={{backgroundColor: 'rgb(75, 123, 176)', padding: '7px 25px', float: 'right', marginLeft: '10px'}}
                            onClick={()=>this.exportFile()}
                        >
                            <a style={{textDecoration: 'none', color: 'white'}}>Export</a>
                        </button> */}
                        </div>
                        <div className="col-md-6">
                        <div>
                            <table>
                            <tbody><tr><td><h6 style={{fontSize: '20px', marginRight: '10px'}}>Class</h6></td>
                                <td>
                                    <select 
                                        className="form-select" 
                                        aria-label=".form-select-lg example" 
                                        style={{margin: '6px 0px'}}
                                        value={slectedGrade}
                                        onChange={this.OnEventChange.bind(this)}
                                    >
                                        <option value={"ALL"}>All</option>
                                        <option value={"Fellow"}>Fellow</option>
                                        <option value={"Member"}>Member</option>
                                        <option value={"Associate Member"}>Associate Member</option>
                                        <option value={"Associate"}>Associate</option>
                                        <option value={"Graduate"}>Graduate</option>
                                        <option value={"Subscriber"}>Subscriber</option>
                                    </select>
                                </td>
                                </tr>
                            </tbody></table>
                        </div>
                        </div>
                        <div className="col-md-6 topnav">
                        <div className="search-container" style={{position: 'relative', float: 'right', marginRight: '37px'}}>
                            <input 
                                type="text" 
                                placeholder="Search.." 
                                name="search"
                                value={searchValue}
                                onChange={this.onSearchTextChange.bind(this)}
                             />
                            <button type="submit" style={{position: 'absolute', marginLeft:'2px'}} onClick={()=>this.onSearchClick()}>
                            <i className="fa fa-search" />
                            </button>
                        </div>
                        </div>
                    </div>
                    <div className="table-responsive">
                    <DataTable
                            columns={this.Header}
                            data={memberList}
                            noHeader={true}
                            fixedHeader={true}
                            fixedHeaderScrollHeight="450px"
                            pagination
                            paginationServer
                            paginationTotalRows={totalRows}
                            // onChangeRowsPerPage={this.getStudentList}
                            onChangePage={this.getMemberListBasedonClass}
                            //paginationRowsPerPageOptions={[]}
                            paginationComponentOptions={paginationComponentOptions}
                            paginationPerPage ={50}
                            style={{maxHeight:'100%'}}
                        />
                       
                        <button type="button" onClick={()=>this.goBack()} className="question-button btn btn-white">Back</button>
                    </div>
                    </div>
                    <div className="modal" id="myModal1">
                    <div className="modal-dialog modal-dialog-centered modal-dialog-md">
                        <div className="modal-content">
                        {/* Modal Header */}
                        <div className="modal-header">
                            <h4 className="modal-title">Delete Question Bank</h4>
                            <button type="button" className="btn-close" data-bs-dismiss="modal">X</button>
                        </div>		
                        {/* Modal body */}
                        <div className="modal-body" style={{overflowX: 'auto', padding: '30px'}}>
                            <h5 style={{fontWeight: 400, fontSize: '22px'}}>Are you sure you want to delete the Question Bank?</h5>
                        </div>
                        {/* Modal footer */}
                        <div className="modal-footer">
                            <button type="button" className="btn Submit-btn">
                            <a href="#">OK</a>
                            </button>
                            <button type="button" className="btn Cancel-btn" data-bs-dismiss="modal">CANCEL</button>
                        </div>
                        </div>
                    </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default searchMembers;